(ns assemble.resource.premade-templates
  (:require [re-frame.core :as rf]))

(rf/reg-sub :premade-templates/is-premade-templates-advertiser?
  :<- [:config]
  :<- [:context]
  (fn [[config context] [_]]
    (= (select-keys (:premadeTemplates config) [:agency-id :advertiser-id])
       (select-keys context [:agency-id :advertiser-id]))))
